/* eslint-disable */
class CartUpsellItem extends HTMLElement {
  constructor() {
    super();

    this.addItems = [...this.querySelectorAll('[data-upsell-add]')];
    this.showForms = [...this.querySelectorAll('[data-upsell-show-form]')];
    this.upsellForm = document.querySelector('[data-upsell-variant-form]');

    this.cartContainer = document.querySelector('#CartContainer')
  }

  connectedCallback() {
    if (this.showForms.length > 0) {
      this.getUpsellFormContents();
    }

    this.addItems.forEach((button) => {
      button.addEventListener('click', this.handleSubmit.bind(this));
    })

    this.showForms.forEach((button) => {
      button.addEventListener('click', this.handleShowForm.bind(this));
    })
  }

  handleSubmit(e) {
    e.preventDefault();
    const data = {
      id : this.dataset.id,
      quantity : 1
    }, callback = (line_item) => {
        ajaxCart.load();
    }, errorCallback = (XMLHttpRequest, textStatus) => {
    };

    window.itemAddedFromUpsell = true
    ShopifyAPI.addMultipleItems(data, callback, errorCallback);
  }

  async getUpsellFormContents() {
    const getSectionHtml = (html, selector) => {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    const url = `${window.Shopify.routes.root}products/${this.dataset.handle}?view=upsell-form`
    const content = await fetch(url)
    .then((response) => {
      if (response.ok) {
        return response.text();
      } else {
        return false;
        // throw new Error('Something went wrong');
      }
    })
    .catch((error) => {
      console.log(error)
    });

    if (content != '') {
      const script = document.createElement('script');
      script.classList.add(`upsell-item-form-${this.dataset.productId}`);
      script.setAttribute('type', 'text/template');
      script.innerHTML = getSectionHtml(content, '[data-cart-upsell-item-wrap]');

      const wrap = document.querySelector('[data-cart-upsell-form-markups]');
      if (wrap) {
        wrap.append(script);
      } else {
        document.body.append(script);
      }
    }
  }

  // Quick View Popup Events
  handleShowForm(e) {
    e.preventDefault();
    const markup = document.querySelector(`.upsell-item-form-${this.dataset.productId}`);
    if (markup) {
      if (this.upsellForm) {
        this.upsellForm.innerHTML = markup.innerHTML;
        this._bindFormEvents(this.upsellForm);
        // Show
        this.cartContainer && this.cartContainer.classList.add('show-upsell-drawer');
      }
    }
  }

  _bindFormEvents(form) {
    console.log(form)
    const upsell_variant_checkboxes = form.querySelectorAll('.upsell-item-form__variant');
    const upsell_variant_checkbox_inputs = form.querySelectorAll('.upsell-item-form__variant input');
    const upsell_add_but = form.querySelector('.upsell-item-form__add');
    upsell_variant_checkboxes.forEach((checkbox)=>{
      checkbox.addEventListener("click", function(e){
        form.setAttribute('data-id', checkbox.getAttribute("variant-id"));
        upsell_add_but.disabled = false;
        upsell_variant_checkbox_inputs.forEach((check_input)=>{
          check_input.checked = false;
        })
        checkbox.querySelector('input').checked = true;
      })
    })
    form.querySelector('.upsell-item-form__variant input[data-available="true"]').click();
    if(upsell_add_but){
      upsell_add_but.addEventListener("click", function(){
        const data = {
          id : form.dataset.id,
          quantity : 1
        }, callback = (line_item) => {
            ajaxCart.load();
            document.querySelector('#CartContainer').classList.remove('show-upsell-drawer');
        }, errorCallback = (XMLHttpRequest, textStatus) => {
        };

        window.itemAddedFromUpsell = true;
        ShopifyAPI.addMultipleItems(data, callback, errorCallback);
      })
    }
  }
}

if (!customElements.get('component-upsell-item')) {
  customElements.define('component-upsell-item', CartUpsellItem);
}
